import { Timestamp } from "firebase/firestore";

export enum AiResponseStatus {
    Scheduled = "scheduled",
    Processing = "processing",
    Complete = "complete",
    QuotaExceeded = "quota_exceeded",
    Error = "error",
}

export enum AiResponseType {
    MskScoreSummary = "msk_score_summary",
}

export interface AiResponse {
    id: string;
    type: AiResponseType;
    status: AiResponseStatus;

    // --- Ownership ---
    organizationId?: string;

    // --- Payload ---
    input: Record<string, any>;
    output?: Record<string, any>;
    outputResponseLanguage?: string;

    // --- Agent (from env: AZURE_AI_MSK_AGENT_ID) ---
    agentName: string;
    agentVersion: string;

    // --- Model (from Azure response.data.model) ---
    modelDeployment?: string;

    // --- Azure response ID (from Azure response.data.id) ---
    responseId?: string;

    // --- Token Usage (from Azure response.data.usage) ---
    inputTokens?: number;
    outputTokens?: number;
    totalTokens?: number;

    // --- Latency (calculated: ms before/after Azure call) ---
    latencyMs?: number;

    // --- Error / Retry ---
    retryCount: number;
    error?: string;

    // --- User Feedback ---
    isLiked?: boolean;

    // --- Audit ---
    createdBy?: string;
    updatedBy?: string;

    // --- Timestamps ---
    created: Timestamp; // Firebase Timestamp
    updated: Timestamp; // Firebase Timestamp
}

// ── Type-specific output shapes ─────────────────

export interface MskScoreSummaryOutput {
    beatOneMskScoreBenchmark: string;
    beatTwoMskRiskSummary: string;
    beatThreePainSummary: string;
    beatFourFocusAreasSummary: string;
    beatFiveClosingInsight: string;
}

// ── Discriminated helpers for consumers ────────

export interface MskScoreSummaryAiResponse extends AiResponse {
    type: AiResponseType.MskScoreSummary;
    output: MskScoreSummaryOutput;
}